import type { InfoPageContent } from './infoTypes';

export const disclaimerContent: InfoPageContent = {
  title: 'Disclaimer',
  tagline: 'A research tool — not financial advice. Read this before relying on anything in the application.',
  lastUpdated: 'August 7, 2026',
  sections: [
    {
      heading: '1 · Not financial advice',
      paragraphs: [
        'Pilum Trade Lab presents data-driven research observations, not advice. It does not know the future, does not issue entry or exit commands, and does not recommend buying or selling any asset. Nothing here should be treated as a solicitation or recommendation.',
      ],
    },
    {
      heading: '2 · No guarantees',
      paragraphs: [
        'Candidate observations are produced from public market data that can be delayed, incomplete, or incorrect. A candidate thesis can be invalidated at any moment. Past or observed behaviour is not a guarantee of future direction.',
      ],
    },
    {
      heading: '3 · Abstention is a feature',
      paragraphs: [
        'The application deliberately abstains when evidence is insufficient: an empty Predictor with a stated reason is better than a forced guess. Treat any observation as a hypothesis to verify, not a verdict to follow.',
      ],
    },
    {
      heading: '4 · Volatility, leverage, and liquidity',
      paragraphs: [
        'Crypto direction can change suddenly because of leverage, liquidity, manipulation, news, and wider market pressure. High-leverage perpetuals can move against a thesis faster than any dashboard can refresh. Review the evidence, the support and resistance scenarios, and your own risk tolerance.',
      ],
    },
    {
      heading: '5 · Do your own research',
      paragraphs: [
        'Use the application as a starting point. Check the primary sources, verify the numbers, and research the project itself before making any decision. Only you can weigh the risk.',
      ],
    },
    {
      heading: '6 · Operating boundary',
      paragraphs: [
        'Monitoring works while the application is open in your browser. Browsers may suspend inactive or closed tabs, so the application does not and cannot provide alerts after it is closed. Do not rely on it as a 24/7 monitoring service.',
      ],
      note: 'Crypto trading involves substantial risk of loss. If you are unsure, consult a qualified professional. Nothing in this application constitutes advice to trade.',
    },
  ],
};
